import { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';
import { BrowserRouter as Router } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  const [t, i18n] = useTranslation('global');
  const [selectedOption, setSelectedOption] = useState('usa');
  const [selectedFlag, setSelectedFlag] = useState('https://res.cloudinary.com/ddqq4wrkw/image/upload/v1766330751/usa_flag_pj8fpu.png');
  const [isOpen, setIsOpen] = useState(false);
  const [options] = useState([
    { value: 'spain', label: 'Esp', image: 'https://res.cloudinary.com/ddqq4wrkw/image/upload/v1766330751/spain_nzd4pi.png' },
    { value: 'germany', label: 'Deu', image: 'https://res.cloudinary.com/ddqq4wrkw/image/upload/v1766330750/Flag_of_Germany.svg_qqmvqw.png' },
    { value: 'japan', label: 'Jpn', image: 'https://res.cloudinary.com/ddqq4wrkw/image/upload/v1766330751/Flag_of_Japan.svg_piekmn.png' },
    { value: 'usa', label: 'Eng', image: 'https://res.cloudinary.com/ddqq4wrkw/image/upload/v1766330751/usa_flag_pj8fpu.png' },
  ]);

  const handleOptionChange = async (option, flag) => {
    setSelectedOption(option);
    setSelectedFlag(flag);
    
    // Load language dynamically if not already loaded
    const loadLanguage = async (lng) => {
      if (!i18n.hasResourceBundle(lng, 'global')) {
        try {
          let translation;
          switch (lng) {
            case 'es':
              translation = await import('../translations/esp/global.json');
              break;
            case 'de':
              translation = await import('../translations/deu/global.json');
              break;
            case 'jp':
              translation = await import('../translations/jpn/global.json');
              break;
            default:
              return;
          }
          i18n.addResourceBundle(lng, 'global', translation.default || translation, true, true);
        } catch (error) {
          console.error(`Failed to load language ${lng}:`, error);
        }
      }
    };
    
    if (option === 'usa') {
      i18n.changeLanguage('en');
    } else if (option === 'spain') {
      await loadLanguage('es');
      i18n.changeLanguage('es');
    } else if (option === 'germany') {
      await loadLanguage('de');
      i18n.changeLanguage('de');
    } else if (option === 'japan') {
      await loadLanguage('jp');
      i18n.changeLanguage('jp');
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    let ticking = false;
    
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolled(window.scrollY > 50);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? 'scrolled' : ''}>
        <Container>
          <Navbar.Brand href="/">
            <h1 className="cursor-pointer logo">Maximo O.</h1>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon" />
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">

            <Nav className="ms-auto">
              <Nav.Link
                href="#home"
                className={
                  activeLink === 'home' ? 'active navbar-link' : 'navbar-link'
                }
                onClick={() => onUpdateActiveLink('home')}
              >
                {t('header.home')}
              </Nav.Link>
              <Nav.Link
                href="#projects"
                className={
                  activeLink === 'projects'
                    ? 'active navbar-link'
                    : 'navbar-link'
                }
                onClick={() => onUpdateActiveLink('projects')}
              >
                {t('header.projects')}
              </Nav.Link>
              <Nav.Link
                href="#cv"
                className={
                  activeLink === 'cv'
                    ? 'active navbar-link'
                    : 'navbar-link'
                }
                onClick={() => onUpdateActiveLink('cv')}
              >
                {t('header.cv')}
              </Nav.Link>
              <Nav.Link
                href="#certifications"
                className={
                  activeLink === 'certifications'
                    ? 'active navbar-link'
                    : 'navbar-link'
                }
                onClick={() => onUpdateActiveLink('certifications')}
              >
                {t('header.certifications')}
              </Nav.Link>
              <Nav.Link
                href="#skills"
                className={
                  activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'
                }
                onClick={() => onUpdateActiveLink('skills')}
              >
                {t('header.skills')}
              </Nav.Link>

              <span className="navbar-text">
                <HashLink to="#connect">
                  <button className="vvd">
                    <span>{t('header.connect')}</span>
                  </button>
                </HashLink>
              </span>

              <div className={`drop-down ${isOpen ? 'open' : ''}`}>
                <div className="wrapper" onClick={toggleMenu}>
                  <img src={selectedFlag} className="selectedImg" alt="" />
                  <div className="selected">{options.find((opt) => opt.value === selectedOption)?.label}</div>
                </div>
                {isOpen && (
                <div className="list">
                  {options.map((opt, index) => (
                    <div className="lengcategory" key={index} onClick={() => handleOptionChange(opt.value, opt.image)}>
                      <img src={opt.image} alt="flags" className="selectedImg" />
                      <div className="selected text">{opt.label}</div>
                    </div>
                  ))}
                </div>
                )}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
